export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40766cd07da9a3bd6f14e7b297b499d5bd554d44e3&name=revalidateCommunity!'